var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 73,
    height: 62,
    viewBox: "0 0 73 62",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.6133 37.6084C25.9948 37.7486 27.0732 38.9155 27.0732 40.334C27.0729 41.8465 25.8465 43.0729 24.334 43.0732C22.9155 43.0732 21.7486 41.9948 21.6084 40.6133L21.5938 40.334L21.6084 40.0537C21.7486 38.6722 22.9155 37.5938 24.334 37.5938L24.6133 37.6084ZM37.9473 37.6084C39.3285 37.7489 40.4062 38.9157 40.4062 40.334C40.4059 41.8466 39.1797 43.0731 37.667 43.0732C36.2485 43.0732 35.0816 41.9948 34.9414 40.6133L34.9277 40.334L34.9414 40.0537C35.0816 38.6722 36.2485 37.5938 37.667 37.5938L37.9473 37.6084ZM21.1201 16.2656C21.7141 16.3162 22.2176 16.7393 22.3643 17.3262L22.7646 18.9277H41.667C42.0998 18.9278 42.509 19.1267 42.7754 19.4678C43.0417 19.809 43.1362 20.2548 43.0312 20.6748L40.3643 31.3418C40.2075 31.9673 39.6449 32.4061 39 32.4062H23.667C23.3392 32.4062 23.0734 32.6722 23.0732 33C23.0734 33.3278 23.3392 33.5938 23.667 33.5938H39C39.7764 33.5939 40.4061 34.2236 40.4062 35C40.4061 35.7764 39.7764 36.4061 39 36.4062H23.667C21.7859 36.4062 20.2609 34.8811 20.2607 33C20.2609 31.5001 21.2306 30.227 22.5771 29.7725L19.9023 19.0732H17.667C16.8905 19.0732 16.2609 18.4435 16.2607 17.667C16.2607 16.8903 16.8903 16.2607 17.667 16.2607H21L21.1201 16.2656Z",
    fill: "#15CDCB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCart);
export default __webpack_public_path__ + "static/media/cart.235b838c9e20e6d97b5e362d2a7b0000.svg";
export { ForwardRef as ReactComponent };